require('./mortgageRequestRNCWelcomeView.scss');

// @ vendors
const React = require('react');

// @ helpers
const { formatText, FormattedText } = require('core/i18n').i18n;

// @ commons
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKCover } = require('commonsComponents/OKCover');
const { ContentBox } = require('commonsComponents/contentBox');
const { OKBoxTitle } = require('commonsComponents/OKBoxTitle');
const { OKLink } = require('commonsComponents/OKLink');

const MortgageRequestRNCWelcomeView = () => {
    const mappingBreadcrumb = [
        {
            text: formatText('mortgageRequestPresentation-title'),
            url: '/myprofile/mortgage/panel'
        },
        {
            text: formatText('mortgageRequestRNCWelcomeView-mortgageRequestRNCWelcomeView_breadCrumbText'),
            url: ''
        }
    ];

    const finalTitle = formatText('mortgageRequestRNCWelcomeView-mortgageRequestRNCWelcomeView_title');
    const errorTitle = formatText('mortgageRequestRNCWelcomeView-mortgageRequestRNCWelcomeView_errorTitle');
    const goBackButtonLabel = formatText('mortgageRequestRNCWelcomeView-mortgageRequestRNCWelcomeView_goBackLabel');
    const goBackButtonLink = '/myprofile/mortgage/pre-approval';

    return (
        <div className="grid-view">
            <div className="container-fluid">
                <div className="row">
                    <OKCover size="medium" section="loansmortgages" customClass="col-xs-12">
                        <OKHeaderSubPage
                            breadcrumbConfig={mappingBreadcrumb}
                            finalTitle={finalTitle}
                        />
                    </OKCover>
                </div>
            </div>
            <div className="grid-view__body">
                <div className="container-fluid">
                    <div className="row grid-view--content-position-negative">
                        <div className="col-xs-8 col-xs-offset-2">
                            <ContentBox>
                                <i className="mortgage-request-rnc-welcome-view__error-icon" />
                                <div className="mortgage-request-rnc-welcome-view__title">
                                    <OKBoxTitle value={errorTitle} />
                                </div>
                                <div className="mortgage-request-rnc-welcome-view__content">
                                    <FormattedText value="mortgageRequestRNCWelcomeView-mortgageRequestRNCWelcomeView_content" />
                                </div>
                                <div className="mortgage-request-rnc-welcome-view__footer">
                                    <div className="mortgage-request-rnc-welcome-view__link">
                                        <OKLink modifier="complementary" to={goBackButtonLink} >
                                            {goBackButtonLabel}
                                        </OKLink>
                                    </div>
                                </div>
                            </ContentBox>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

module.exports = MortgageRequestRNCWelcomeView;
